<ng-container *ngIf="officeCodes; else loader">
  <button type="button" class="btn btn-outline-primary segments-filters__toggle" (click)="toggleFilters()">
    <span class="fa-filter" i18n="@@segments-filters.buttonFiltersToggle"></span>
    Filter
  </button>
  <div *ngIf="opened && !isMobile" class="card" @toggle>
    <div class="card-body">
      <ng-container *ngTemplateOutlet="filters"></ng-container>
    </div>
  </div>
  <ul *ngIf="!opened" class="option-badges" style="padding-inline-start: 0px;" @toggle>
    <li *ngFor="let label of badgeLabels" class="badge rounded-pill bg-light me-2 mb-2">{{ label }}</li>
  </ul>
</ng-container>

<ng-template #filtersModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@segments.filters.buttonFiltersToggle">Filter</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="d()"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="filters"></ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="d()" i18n="@@segments-filters.buttonCancel">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="c()" i18n="@@segments-filters.buttonApplyFilters">
      See results
    </button>
  </div>
</ng-template>

<ng-template #filters>
  <form [formGroup]="formGroup" class="segments-options">
    <div class="row">
      <p-form-group class="col-md-4 col-xl-3" label="{{ accountInvoicesFilterLabelDateFrom }}">
        <df-monthpicker
          pFormControlInput
          formControlName="dateFrom"
          title="{{ accountInvoicesFilterLabelDateFrom }}"
          [errorMessage]="getDateErrorMessage(dateFromControl)"
          (keyup.enter)="dateFromControl.markAsTouched()"
          (click)="dateFromControl.markAsUntouched()"
          [valid]="!dateFromControl.touched || dateFromControl.valid"
        ></df-monthpicker>
      </p-form-group>

      <p-form-group class="col-md-4 col-xl-3" label="{{ accountInvoicesFilterLabelDateTo }}">
        <df-monthpicker
          pFormControlInput
          formControlName="dateTo"
          title="{{ accountInvoicesFilterLabelDateTo }}"
          [errorMessage]="getDateErrorMessage(dateToControl)"
          (keyup.enter)="dateToControl.markAsTouched()"
          (click)="dateToControl.markAsUntouched()"
          [valid]="!dateToControl.touched || dateToControl.valid"
        ></df-monthpicker>
      </p-form-group>

      <p-form-group label="Offices" class="col-md-4 col-xl-3">
        <ng-select
          dfManageNavSelect
          id="segments-office-codes"
          formControlName="offices"
          [items]="officeCodes"
          bindValue="value"
          [multiple]="true"
          [groupBy]="groupByFn"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true"
          [clearable]="false"
          placeholder="None"
          i18n-placeholder="@@segments-filters.multiselectValueNoneSelected"
        >
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <ng-container *ngIf="items?.length < officesLength; else allSelected">
              <div class="ng-value">
                <span class="ng-value-label">{{ items[0].value }}</span>
                <span *ngIf="items?.length > 1" aria-hidden="true">, </span>
              </div>
              <div class="ng-value" *ngIf="items?.length > 1">
                <span class="ng-value-label">{{ multiselectValueShortened + (items?.length - 1) }}</span>
              </div>
            </ng-container>
            <ng-template #allSelected>
              <div class="ng-value" *ngIf="items?.length === officesLength">
                <span class="ng-value-label" i18n="@@segments-filters.multiselectValueAllSelected">All</span>
              </div>
            </ng-template>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item$="item$" let-index="index" let-search="searchTerm">
            <div class="form-check">
              <input
                id="office-group-{{ index }}"
                class="form-check-input"
                name="office-group-{{ index }}"
                type="checkbox"
                [ngModel]="isAll(item$)"
                (ngModelChange)="item$.selected = $event"
                [ngModelOptions]="{ standalone: true }"
              />
              <label
                class="form-check-label"
                for="office-group-{{ index }}"
                (click)="$event.preventDefault()"
                [dfOptionHighlight]="search"
                i18n="@@segments-filters.multiselectValueAllSelected"
                >All</label
              >
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
            <div class="form-check form-check-inline ms-3">
              <input
                id="office-item-{{ index }}"
                name="office-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone: true }"
              />
              <label
                class="form-check-label"
                for="office-item-{{ index }}"
                (click)="$event.preventDefault()"
                [dfOptionHighlight]="search"
                >{{ item?.label }}</label
              >
            </div>
          </ng-template>
        </ng-select>
        <span
          *ngIf="!formGroup.value.offices.length"
          class="invalid-feedback"
          i18n="@@segments-filters.accountInvoicesValidationSelectOffice"
        >
          Select at least one office
        </span>
      </p-form-group>

      <p-form-group label="Segments" class="col-md-4 col-xl-3">
        <ng-select
          id="segments"
          formControlName="segment"
          [items]="segmentOptions"
          bindValue="value"
          [searchable]="false"
          [clearable]="false"
        >
          <ng-template ng-option-tmp let-item="item">
            <span class="ng-option-label" [innerText]="(!item?.value && item?.label) || item?.label"></span>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span class="ng-value-label" [innerText]="(!item?.value && item?.label) || item?.label"></span>
          </ng-template>
        </ng-select>
      </p-form-group>
      <p-form-group label="Providers" class="col-md-4 col-xl-3">
        <ng-select
          id="providers"
          formControlName="provider"
          [items]="providerOptions"
          [searchable]="false"
          [clearable]="false"
          bindValue="value"
          #provider
        >
          <ng-template ng-option-tmp let-item="item">
            <span class="ng-option-label" [innerText]="(!item?.value && item?.label) || item?.label"></span>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span class="ng-value-label" [innerText]="(!item?.value && item?.label) || item?.label"></span>
          </ng-template>
        </ng-select>
        <span *ngIf="provider.disabled && provider.items.length !== 2" class="hint-message">
          <ng-container
            *ngIf="formGroup.value.segment === 'All'; else noProviders"
            i18n="@@segments-filters.accountInvoicesValidationSelectSegment"
          >
            Select a segment before choosing
          </ng-container>
          <ng-template #noProviders i18n="@@segments-filters.accountInvoicesValidationNoProviders"
            >Information is not available for this segment</ng-template
          >
        </span>
      </p-form-group>
    </div>
  </form>
</ng-template>

<ng-template #loader>
  <spinner [fixed]="true"></spinner>
</ng-template>
